import { Component, OnInit, ViewChild } from '@angular/core';
import {MatExpansionModule} from '@angular/material/expansion'; 
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

export interface attachmentElement {
  attachReview: string;
  position: number;
}

const attachmentData: attachmentElement[] = [
  {position: 1, attachReview: 'local.pdf'},
  {position: 2, attachReview: 'manual.pdf'},
];

export interface task {
  linkReview: string;
  position: number;
}

const taskToReview: task[] = [
  {position: 1, linkReview: 'Task 1'},
  {position: 2, linkReview: 'Task 2'},
];
@Component({
  selector: 'app-notes-attachement-dialog',
  templateUrl: './notes-attachement-dialog.component.html',
  styleUrls: ['./notes-attachement-dialog.component.css']
})
export class NotesAttachementDialogComponent implements OnInit {
  panelOpenState = true;
  panelOpenStateNotes = true;

  constructor(private differs:MatExpansionModule) { }

  ngOnInit(): void {
  }

  displayedColumns: string[] = ['position', 'attachReview'];
  dataSource = new MatTableDataSource<attachmentElement>(attachmentData);

  displayedTaskColumns: string[] = ['position', 'tskReview'];
  dataTaskSource = new MatTableDataSource<task>(taskToReview);

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  @ViewChild(MatPaginator)
  paginatorTask!: MatPaginator;

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataTaskSource.paginator = this.paginatorTask;
  }

}
